import { Helmet } from "react-helmet-async";

import {
  Button,
  ColumnContainer,
  Label,
  LabelL,
  LabelXXL,
  LimitedContainerMedium,
  Panel,
  SafePanel,
  Space,
} from "../components/Ui/Ui";
import { PrivacyPageMetaData } from "../data/MetaData";
import { privacyPageMainData } from "../data/PrivacyData";
import { useCookies } from "react-cookie";
const Privacy = () => {
const [cookies, setCookie, removeCookie] = useCookies();

  const handleClearCookies = () => {
    // Alle Cookies auslesen
    Object.keys(cookies).forEach((cookieName) => {
      // Löschen jedes einzelnen Cookies
      removeCookie(cookieName, { path: '/' });
    });
  };
  return (
    <>
      {/* <Helmet>
        <title>{PrivacyPageMetaData.title}</title>
        {PrivacyPageMetaData.meta.map((meta, index) => (
          <meta
            key={index}
            {...(meta.property
              ? { property: meta.property }
              : { name: meta.name })}
            content={meta.content}
          />
        ))}
        <link rel="canonical" href={PrivacyPageMetaData.canonical} />
        <script type="application/ld+json">
          {JSON.stringify(PrivacyPageMetaData.structuredData)}
        </script>
      </Helmet> */}
                 <Helmet>
                                    <title>{PrivacyPageMetaData.title}</title>
                                    <meta
                                      name="description"
                                      content={PrivacyPageMetaData.content}
                                    />
                                  </Helmet>
      <Panel style={{ background: "white" }}>
        <SafePanel>
          <ColumnContainer>
            <LabelXXL color="black" fontWeight="900">
              {privacyPageMainData.title}
            </LabelXXL>
            {/* <button
              onClick={() => {
                resetCookieConsentValue();
                // Weitere Aktionen, z.B. erneutes Anzeigen des Banners
              }}
            >
              Cookie-Einstellungen ändern
            </button> */}
            <Space style={{ height: "2rem" }} />
            {privacyPageMainData.privacyData.map((element, index) => (
              <ColumnContainer>
                <LabelL
                  style={{ color: "black", fontWeight: "600" }}
                  key={index}
                >
                  {element.title}
                </LabelL>
                {element.descriptions.map((element2, index) => (
                  <ColumnContainer>
                    <LimitedContainerMedium>
                      <Label style={{ color: "black" }} key={index}>
                        {element2}
                      </Label>
                    </LimitedContainerMedium>
                  </ColumnContainer>
                ))}
                <Space style={{ height: "2rem" }} />
              </ColumnContainer>
            ))}
            <Button style={{backgroundColor:"red"}} onClick={handleClearCookies}>Cookies Löschen</Button>

            {/* <CookieConsent
              visible={getCookieConsentValue() ? "hidden" : "show"}
              onAccept={() => {
                // Aktionen nach Zustimmung
              }}
              onDecline={() => {
                // Aktionen nach Ablehnung
              }}
            >
              Wir verwenden Cookies, um Ihnen das bestmögliche Erlebnis auf
              unserer Website zu bieten.{" "}
              <button
                onClick={() => {
                  resetCookieConsentValue();
                  // Weitere Aktionen, z.B. erneutes Anzeigen des Banners
                }}
              >
                Cookie-Einstellungen ändern
              </button>
            </CookieConsent> */}
          </ColumnContainer>
        </SafePanel>
      </Panel>
    </>
  );
};

export default Privacy;
